import { useIsMaventaIntegrationEnabledQuery } from 'store/api/maventa-integration';
import { useIsNetvisorIntegrationEnabledQuery } from 'store/api/netvisor-integration';

/** A contact's e-invoicing details are used by both Netvisor and Maventa, so either one shows them. */
export const useIsEinvoicingEnabled = (): { data: boolean; isLoading: boolean } => {
    const netvisor = useIsNetvisorIntegrationEnabledQuery();
    const maventa = useIsMaventaIntegrationEnabledQuery();

    return {
        data: netvisor.data === true || maventa.data === true,
        isLoading: netvisor.isLoading || maventa.isLoading,
    };
};
